<div mat-dialog-title fxLayoutAlign="space-between center">
  <h2>{{ file.documentTitle }}</h2>

  <div *ngIf="file.type === 'image'">
    <button mat-icon-button (click)="zoom('in')" matTooltip="Zoom in">
      <mat-icon>zoom_in</mat-icon>
    </button>
    <button
      mat-icon-button
      (click)="zoom('out')"
      matTooltip="Zoom out"
      [disabled]="zoomScale <= 0.5"
    >
      <mat-icon>zoom_out</mat-icon>
    </button>
    <button
      mat-icon-button
      (click)="rotate('left')"
      matTooltip="Rotate counter-clockwise"
    >
      <mat-icon>rotate_left</mat-icon>
    </button>
    <button
      mat-icon-button
      (click)="rotate('right')"
      matTooltip="Rotate clockwise"
    >
      <mat-icon>rotate_right</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content>
  <ng-container *ngIf="isTextFile; else defaultEl">
    <ng-container *ngIf="loadingTextContent$ | async; else textContentEl">
      <div fxFlexLayout="row" fxLayoutAlign="center center" style="min-height: 250px;">
        <mat-spinner [diameter]="35"></mat-spinner>
      </div>
    </ng-container>
    <ng-template #textContentEl>
      <ngx-json-viewer *ngIf="file.extension === '.json'; else basicTextEl" [json]="jsonContent"></ngx-json-viewer>

      <ng-template #basicTextEl>
        <div>
          <pre>{{ textContent }}</pre>
        </div>
      </ng-template>
    </ng-template>
  </ng-container>

  <ng-template #defaultEl>
    <div
      fxLayout="column"
      fxLayoutAlign="center center"
    >
      <img
        *ngIf="file.type === 'image'"
        [src]="file.signedUrl"
        [style.transform]="transform"
      />
      <object
        *ngIf="file.extension === '.pdf'"
        [data]="pdfUrl"
        type="application/pdf"
        width="100%"
        height="1000px"
      ></object>

      <div *ngIf="file.type !== 'image' && file.extension !== '.pdf'" class="pt-5 pb-5">
        No preview is available for this file.
      </div>
    </div>
  </ng-template>
  <mat-error *ngIf="errorMessage">{{ errorMessage }}</mat-error>
</mat-dialog-content>

<mat-dialog-actions fxLayoutAlign="space-between center">
  <button mat-stroked-button mat-dialog-close>Close</button>
  <button mat-flat-button color="warn" (click)="deleteFile()">Delete</button>
  <button
    mat-flat-button
    cdkFocusInitial
    color="primary"
    (click)="downloadFile()"
  >
    Download
  </button>
</mat-dialog-actions>
